const firebase = require('firebase')
// Initialize Firebase
var config = {
    apiKey: "AIzaSyCTWNbsRVJeFA57nzQkWqxDROVB_VLYsGw",
    authDomain: "afa-menus.firebaseapp.com",
    databaseURL: "https://afa-menus.firebaseio.com",
    projectId: "afa-menus",
    storageBucket: "afa-menus.appspot.com",
    messagingSenderId: "750760945626"
  };
let menumaker = firebase.initializeApp(config, 'menumaker');

module.exports = menumaker
